<template>
  <div class="profile-layout sample-profile type-profile">
    <sample-navbar></sample-navbar>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'About the Data',
              icon: 'help',
              path: '/sample/industry-market-profile/about-the-data',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Competitors',
              icon: 'location_on',
              path: '/sample/industry-market-profile/competitors',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'market' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Market',
                icon: 'trending_up',
                path: '/sample/industry-market-profile/market',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'balance-sheet' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Annual Sales',
                icon: 'area_chart',
                path: '/sample/industry-market-profile/annual-sales',
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Penetration',
              icon: 'business',
              path: '/sample/industry-market-profile/penetration',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Employment',
              icon: 'account_box',
              path: '/sample/industry-market-profile/employment',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Sales/Emp Classes',
              icon: 'price_change',
              path:
                '/sample/industry-market-profile/sales-emp-classes',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Productivity',
              icon: 'work',
              path: '/sample/industry-market-profile/productivity',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Startups',
              icon: 'settings_input_antenna',
              path: '/sample/industry-market-profile/startups',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Cessation',
              icon: 'area_chart',
              path: '/sample/industry-market-profile/cessation',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Ownership',
              icon: 'location_city',
              path: '/sample/industry-market-profile/ownership',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Demographics',
              icon: 'home',
              path: '/sample/industry-market-profile/demographics',
            }"
          ></sidebar-item>
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <!-- your content here -->
              <router-view :headerData="headerData" v-if="!loading || isAboutRoute" />
             <!--<PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>-->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import SampleNavbar from './SampleNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { PulseLoader } from '@/components';
import Vuex, { mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'sample-market-profile-layout',
  components: {
    SampleNavbar,
    ContentFooter,
    MobileMenu,
    PulseLoader,
  },
  data() {
    return {
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      loading: true,
      isAboutRoute: false,
      headerData: {
        area: "Zip Codes 17011,17043,17055",
        bznaics: "238220.000000",
        client_logo: null,
        client_name: null,
        developer_logo: null,
        developer_name: null,
        error: false,
        errorCode: "none",
        industry: "Plumbing, Heating, and Air-Conditioning Contractors",
        isReport: false,
        sales_class: null,
        sector: "Construction",
        title: "Industry Market Profile"
      },
    };
  },
  methods: {
    ...mapActions({
      alertSuccess: 'alerts/success',
      alertError: 'alerts/error',
    }),
    async init() {
      this.getHeaderData();
      this.loading = true;

      await this.$store.dispatch('sample/getIMRProfile').then((res) => {
         this.$store.commit('user/SET_CMN_TEXT', res.cmnText);

        if (res && res.mapImage) {
          res.data.mapImage = res.mapImage;
        }

        this.$store.commit('user/SET_INDUSTRY_PROFILE', res.data);
        this.loading = false;
      });
    },
    checkRoute() {
      if (this.$route.name === 'SampleMarketAboutTheData')
        return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/productHeader', {
          params: {
            product_id: 18095623,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.headerData = res.data;
        });
    },
  },
  updated() {
  },
  mounted() {
    this.isAboutRoute = this.checkRoute()
    this.init();
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
      profile: (state) => state.user.industryProfile,
    }),
    id() {
      return this.$route.params.id; //18038723
    },
  },
  watch: {
    me: {
      handler: function (val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.pulse {
  height: 120px !important;
  top: 1.7rem !important;
  background: transparent !important;
}
</style>
